import React from "react";
import { Link } from "gatsby";
import HTMLParser from "../../htmlParser";
import Image from "./image";
const NavGrid = (props) => {
    let className = props.attributes.className;
    if (props.attributes.align && props.attributes.align.length) {
        className += " align" + props.attributes.align;
    }
    const images = props.innerBlocks.map((e) => {
        const title = props.navGridTitleForButton
            ? e.attributes.title || "Découvrir"
            : "En savoir plus";
        const TileContent = () => {
            return (React.createElement(React.Fragment, null,
                props.navGridAsBackgroundImages ? (React.createElement(React.Fragment, null)) : (React.createElement(Image, { size: "medium", attributes: e.attributes })),
                props.navGridTitleForButton || !e.attributes.title ? (React.createElement(React.Fragment, null)) : (React.createElement("h3", null, e.attributes.title)),
                e.attributes.caption && e.attributes.caption.length ? (React.createElement("p", null,
                    React.createElement(HTMLParser, null, e.attributes.caption))) : (React.createElement(React.Fragment, null)),
                e.attributes.href && e.attributes.href.length ? (React.createElement("div", { className: "wp-block-button is-style-button-primary" },
                    React.createElement("span", { className: "wp-block-button__link " + e.attributes.linkClass }, title))) : (React.createElement(React.Fragment, null))));
        };
        const linkTitle = e.attributes.title?.length
            ? title + " : " + e.attributes.title
            : e.attributes.alt?.length
                ? title + " : " + e.attributes.alt
                : title;
        return (React.createElement("div", { id: e.anchor, className: "tile" + (e.attributes.className ? " " + e.attributes.className : ""), key: e.attributes.id, style: {
                backgroundImage: props.navGridAsBackgroundImages
                    ? "url(" + e.url + ")"
                    : undefined,
                ...(props.style || {}),
            } }, e.attributes.href && e.attributes.href.length ? (React.createElement(Link, { target: e.attributes.linkTarget, href: e.attributes.href, rel: e.attributes.rel, title: linkTitle },
            React.createElement(TileContent, null))) : (React.createElement(TileContent, null))));
    });
    return (React.createElement("nav", { id: props.anchor || props.attributes.anchor, className: className }, images));
};
export default NavGrid;
